import { FC } from 'react';

import { JobColorEnum } from '../../enum';

interface CoreStatusProps {
  value: string;
  backgroundColor?: string;
}

export const CoreStatus: FC<CoreStatusProps> = ({ value, backgroundColor }) => {
  return (
    <span
      className="py-1 px-2.5 rounded-full font-semibold text-xs whitespace-nowrap w-fit"
      style={{
        backgroundColor,
        color: value === JobColorEnum.WHITE ? '#161617' : 'white',
        border: `0.5px solid ${value === JobColorEnum.WHITE ? 'black' : 'transparent'}`,
        fontWeight: value === JobColorEnum.WHITE ? 400 : 600,
      }}
    >
      {value}
    </span>
  );
};

export const JobCoreStatus: FC<CoreStatusProps> = ({
  value,
  backgroundColor,
}) => {
  return (
    <span
      className="leading-[20px] px-[24px] py-[4px] flex items-center justify-center rounded-full text-white font-semibold text-xs whitespace-nowrap w-fit"
      style={{ backgroundColor }}
    >
      {value}
    </span>
  );
};
